// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
//require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("moment/locale/tr")
moment = require("moment")
require("tempusdominus-bootstrap-4")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'inputmask/dist/inputmask';
import 'inputmask/dist/bindings/inputmask.binding';
import 'daterangepicker/daterangepicker.js';
import 'daterangepicker/daterangepicker.css';
import './styles.scss';


import "@fortawesome/fontawesome-free/js/all";

$(function() {

    $('body').tooltip({
        selector: '[data-toggle="tooltip"]',
        container: 'body',
    });

    $('body').popover({
        selector: '[data-toggle="popover"]',
        container: 'body',
        html: true,
        trigger: 'hover',
    });

    $('input[name="daterange"]').daterangepicker();
    $('input[name="daterange2"]').daterangepicker();

    // Wrap tables in .table-responsive for better mobile support
    $('table.table').each(function() {
        if (!$(this).parent().hasClass('table-responsive')) {
            $(this).wrap('<div class="table-responsive"></div>');
        }
    });

    // Flash mesajlarını 10 saniye sonra otomatik gizle
    const flashContainer = $('.flash-container .alert');
    if (flashContainer.length > 0) {
        setTimeout(function() {
            flashContainer.fadeOut(400, function() {
                $(this).remove();
            });
        }, 10000); // 10 saniye
    }

    // TC Kimlik No input alanları için sadece rakam girişi ve 11 karakter sınırı
    function setupTcknInput(input) {
        if (!input || input.disabled) return;
        
        input.addEventListener('input', function(e) {
            // Sadece rakam girişine izin ver
            this.value = this.value.replace(/\D/g, '');
            // 11 karakter sınırı
            if (this.value.length > 11) {
                this.value = this.value.slice(0, 11);
            }
        });
        
        // Paste olayında da kontrol et
        input.addEventListener('paste', function(e) {
            e.preventDefault();
            const paste = (e.clipboardData || window.clipboardData).getData('text');
            const numbers = paste.replace(/\D/g, '').slice(0, 11);
            this.value = numbers;
        });
    }

    // Tüm TC Kimlik No input'larını bul ve ayarla
    // name attribute'unda "tckn" geçen veya id'sinde "tckn" geçen input'ları bul
    document.querySelectorAll('input[name*="tckn"], input[id*="tckn"]').forEach(function(input) {
        // Sadece maxlength ve pattern attribute'ları yoksa ekle
        if (!input.hasAttribute('maxlength')) {
            input.setAttribute('maxlength', '11');
        }
        // Pattern attribute'unu kaldır (tarayıcı validasyon mesajını engellemek için)
        if (input.hasAttribute('pattern')) {
            input.removeAttribute('pattern');
        }
        if (!input.hasAttribute('inputmode')) {
            input.setAttribute('inputmode', 'numeric');
        }
        setupTcknInput(input);
    });

    // Sadece rakam girişine izin veren genel yardımcı fonksiyon
    function setupNumericInput(input, maxLength) {
        if (!input || input.disabled) return;
        
        input.addEventListener('input', function(e) {
            // Sadece rakam girişine izin ver
            this.value = this.value.replace(/\D/g, '');
            if (this.value.length > maxLength) {
                this.value = this.value.slice(0, maxLength);
            }
        });
        
        // Paste olayında da kontrol et
        input.addEventListener('paste', function(e) {
            e.preventDefault();
            const paste = (e.clipboardData || window.clipboardData).getData('text');
            const numbers = paste.replace(/\D/g, '');
            this.value = numbers.slice(0, maxLength);
        });
    }

    // VKN (tax_number) input'ları için setup - sabit maxlength 11
    document.querySelectorAll('input[name*="tax_number"], input[id*="tax_number"]').forEach(function(input) {
        if (input.hasAttribute('pattern')) {
            input.removeAttribute('pattern');
        }
        if (!input.hasAttribute('inputmode')) {
            input.setAttribute('inputmode', 'numeric');
        }
        if (!input.disabled) {
            input.setAttribute('maxlength', '11');
        }
        setupNumericInput(input, 11);
    });

    // MERSİS (mersis_number) input'ları için setup - sabit maxlength 20
    document.querySelectorAll('input[name*="mersis_number"], input[id*="mersis_number"]').forEach(function(input) {
        if (input.hasAttribute('pattern')) {
            input.removeAttribute('pattern');
        }
        if (!input.hasAttribute('inputmode')) {
            input.setAttribute('inputmode', 'numeric');
        }
        if (!input.disabled) {
            input.setAttribute('maxlength', '20');
        }
        setupNumericInput(input, 20);
    });

    // Doğum tarihi alanları için sadece sayı girişi (eğer text field olarak kalırsa)
    function setupBirthDateInput(input) {
        if (!input || input.disabled || input.tagName === 'SELECT') return;
        
        // Gün için maxlength 2, Ay için maxlength 2, Yıl için maxlength 4
        const fieldName = input.name || input.id || '';
        let maxLength = 4; // Yıl için varsayılan
        if (fieldName.includes('birth_day')) {
            maxLength = 2;
        } else if (fieldName.includes('birth_month')) {
            maxLength = 2;
        }
        
        if (!input.hasAttribute('maxlength')) {
            input.setAttribute('maxlength', maxLength.toString());
        }
        // Pattern attribute'unu kaldır (tarayıcı validasyon mesajını engellemek için)
        if (input.hasAttribute('pattern')) {
            input.removeAttribute('pattern');
        }
        if (!input.hasAttribute('inputmode')) {
            input.setAttribute('inputmode', 'numeric');
        }
        
        input.addEventListener('input', function(e) {
            // Sadece rakam girişine izin ver
            this.value = this.value.replace(/\D/g, '');
            // Maxlength kontrolü
            if (this.value.length > maxLength) {
                this.value = this.value.slice(0, maxLength);
            }
        });
        
        // Paste olayında da kontrol et
        input.addEventListener('paste', function(e) {
            e.preventDefault();
            const paste = (e.clipboardData || window.clipboardData).getData('text');
            const numbers = paste.replace(/\D/g, '').slice(0, maxLength);
            this.value = numbers;
        });
    }

    // Tüm doğum tarihi input'larını bul ve ayarla (text field olarak kalanlar için)
    document.querySelectorAll('input[name*="birth_day"], input[name*="birth_month"], input[name*="birth_year"], input[id*="birth_day"], input[id*="birth_month"], input[id*="birth_year"]').forEach(function(input) {
        setupBirthDateInput(input);
    });

    // Posta Kodu input alanları için sadece rakam girişi ve 5 karakter sınırı
    function setupPostalCodeInput(input) {
        if (!input || input.disabled) return;
        
        input.addEventListener('input', function(e) {
            // Sadece rakam girişine izin ver
            this.value = this.value.replace(/\D/g, '');
            // 5 karakter sınırı (6. karakteri girdirmemeli)
            if (this.value.length > 5) {
                this.value = this.value.slice(0, 5);
            }
        });
        
        // Paste olayında da kontrol et
        input.addEventListener('paste', function(e) {
            e.preventDefault();
            const paste = (e.clipboardData || window.clipboardData).getData('text');
            const numbers = paste.replace(/\D/g, '').slice(0, 5);
            this.value = numbers;
        });
    }

    // Tüm Posta Kodu input'larını bul ve ayarla
    document.querySelectorAll('input[name*="postal_code"], input[id*="postal_code"]').forEach(function(input) {
        // Sadece maxlength ve pattern attribute'ları yoksa ekle
        if (!input.hasAttribute('maxlength')) {
            input.setAttribute('maxlength', '5');
        }
        // Pattern attribute'unu kaldır (tarayıcı validasyon mesajını engellemek için)
        if (input.hasAttribute('pattern')) {
            input.removeAttribute('pattern');
        }
        if (!input.hasAttribute('inputmode')) {
            input.setAttribute('inputmode', 'numeric');
        }
        setupPostalCodeInput(input);
    });

    // Ad/Soyad input alanları için sadece harf + boşluk girişi
    // (TR karakterleri dahil). Validasyon sırasını bozmaz; sadece frontend'de giriş temizliği yapar.
    // Not: Bilerek sadece TR+Latin harfleri kapsıyoruz (A-Z + ÇĞİÖŞÜ + çğıöşü) ve boşluk.
    const nameDisallowedCharsRegex = /[^A-Za-zÇĞİÖŞÜçğıöşü\s]/g;

    function cleanNameValue(value) {
        if (value == null) return '';
        let v = value.toString();
        // Satır sonu/tab gibi whitespace karakterlerini boşluğa çevir
        v = v.replace(/[\t\r\n]+/g, ' ');
        // Harf ve boşluk dışındaki her şeyi çıkar
        v = v.replace(nameDisallowedCharsRegex, '');
        return v;
    }

    function setupNameInput(input) {
        if (!input || input.disabled) return;
        // Sadece text input'larda çalıştır (beklenmedik tiplerde yan etki olmasın)
        if (input.type && input.type !== 'text') return;

        input.addEventListener('input', function(e) {
            const original = this.value || '';
            const cursorPos = typeof this.selectionStart === 'number' ? this.selectionStart : null;

            const cleaned = cleanNameValue(original);
            if (cleaned === original) return;

            // Cursor'ı mümkün olduğunca koru
            if (cursorPos != null) {
                const before = original.slice(0, cursorPos);
                const cleanedBefore = cleanNameValue(before);
                this.value = cleaned;
                const newCursorPos = cleanedBefore.length;
                this.setSelectionRange(newCursorPos, newCursorPos);
            } else {
                this.value = cleaned;
            }
        });

        input.addEventListener('paste', function(e) {
            e.preventDefault();
            const paste = (e.clipboardData || window.clipboardData).getData('text');
            const cleanedPaste = cleanNameValue(paste);

            const original = this.value || '';
            const start = typeof this.selectionStart === 'number' ? this.selectionStart : original.length;
            const end = typeof this.selectionEnd === 'number' ? this.selectionEnd : original.length;

            const before = original.slice(0, start);
            const after = original.slice(end);

            const next = cleanNameValue(before + cleanedPaste + after);
            this.value = next;

            // Cursor'ı paste edilen kısmın sonuna getir
            const newCursorPos = cleanNameValue(before).length + cleanedPaste.length;
            this.setSelectionRange(newCursorPos, newCursorPos);
        });
    }

    // Tüm Ad/Soyad input'larını bul ve ayarla
    document.querySelectorAll(
        'input[name*="first_name"], input[id*="first_name"], input[name*="last_name"], input[id*="last_name"]'
    ).forEach(function(input) {
        setupNameInput(input);
    });

    // GSM (Telefon) input alanları için formatlama ve sınırlama
    function setupGsmInput(input) {
        if (!input || input.disabled) return;
        
        // Telefon numarasını formatla: 0544 232 12 43
        function formatPhoneNumber(value) {
            // Sadece rakamları al
            let numbers = value.replace(/\D/g, '');
            
            // 90 ile başlıyorsa, 05 ile değiştir
            if (numbers.startsWith('90')) {
                numbers = '05' + numbers.substring(2);
            }
            
            // Her zaman 05 ile başlamalı (kullanıcı yazmaya başladığında)
            // Eğer 0 ile başlamıyorsa, başına 05 ekle
            if (!numbers.startsWith('0') && numbers.length > 0) {
                numbers = '05' + numbers;
            } else if (numbers.startsWith('0') && numbers.length === 1) {
                // Sadece "0" varsa, "05" yap
                numbers = '05';
            } else if (numbers.startsWith('0') && !numbers.startsWith('05') && numbers.length > 1) {
                // 0 ile başlıyor ama 05 ile başlamıyorsa, 0'ı 05 ile değiştir
                numbers = '05' + numbers.substring(1);
            }
            
            // Maksimum 11 karakter (0 + 10 hane)
            if (numbers.length > 11) {
                numbers = numbers.substring(0, 11);
            }
            
            // Formatla: 0544 232 12 43 (0 + 3 + 3 + 2 + 2)
            if (numbers.length === 0) return '';
            if (numbers.length <= 1) return numbers;
            if (numbers.length <= 4) return numbers;
            if (numbers.length <= 7) return numbers.substring(0, 4) + ' ' + numbers.substring(4);
            if (numbers.length <= 9) return numbers.substring(0, 4) + ' ' + numbers.substring(4, 7) + ' ' + numbers.substring(7);
            return numbers.substring(0, 4) + ' ' + numbers.substring(4, 7) + ' ' + numbers.substring(7, 9) + ' ' + numbers.substring(9, 11);
        }
        
        // Backend'e göndermeden önce formatı temizle (sadece rakamlar)
        function getCleanPhoneNumber(value) {
            let numbers = value.replace(/\D/g, '');
            // 90 ile başlıyorsa, 05 ile değiştir
            if (numbers.startsWith('90')) {
                numbers = '05' + numbers.substring(2);
            }
            // Her zaman 05 ile başlamalı
            if (!numbers.startsWith('0') && numbers.length > 0) {
                numbers = '05' + numbers;
            } else if (numbers.startsWith('0') && numbers.length === 1) {
                // Sadece "0" varsa, "05" yap
                numbers = '05';
            } else if (numbers.startsWith('0') && !numbers.startsWith('05') && numbers.length > 1) {
                // 0 ile başlıyor ama 05 ile başlamıyorsa, 0'ı 05 ile değiştir
                numbers = '05' + numbers.substring(1);
            }
            // Maksimum 11 karakter
            if (numbers.length > 11) {
                numbers = numbers.substring(0, 11);
            }
            return numbers;
        }
        
        // Input alanına focus olduğunda veya sayfa yüklendiğinde, eğer boşsa otomatik olarak "05" yaz
        function ensureZeroFiveStart() {
            const currentValue = this.value.replace(/\D/g, '');
            if (currentValue.length === 0) {
                // Input boşsa, otomatik olarak "05" yaz
                this.value = '05';
                // Cursor'ı sona al
                this.setSelectionRange(2, 2);
            } else if (currentValue === '0') {
                // Sadece "0" varsa, "05" yap
                this.value = '05';
                this.setSelectionRange(2, 2);
            } else if (!currentValue.startsWith('05') && currentValue.startsWith('0')) {
                // 0 ile başlıyor ama 05 ile başlamıyorsa, 0'ın yanına 5 ekle (eğer sadece 0 varsa)
                if (currentValue.length === 1) {
                    this.value = '05';
                    this.setSelectionRange(2, 2);
                } else {
                    // Zaten rakamlar var, formatla
                    const formatted = formatPhoneNumber(currentValue);
                    this.value = formatted;
                    this.setSelectionRange(formatted.length, formatted.length);
                }
            } else if (!currentValue.startsWith('0')) {
                // 0 ile başlamıyorsa, başına 05 ekle
                const formatted = formatPhoneNumber('05' + currentValue);
                this.value = formatted;
                // Cursor'ı sona al
                this.setSelectionRange(formatted.length, formatted.length);
            }
        }
        
        // Sayfa yüklendiğinde kontrol et
        if (input.value.trim() === '' || input.value.replace(/\D/g, '').length === 0) {
            input.value = '05';
        }
        
        // Focus olduğunda kontrol et
        input.addEventListener('focus', ensureZeroFiveStart);
        
        // Input olayında formatla
        input.addEventListener('input', function(e) {
            const cursorPosition = this.selectionStart;
            const oldValue = this.value;
            
            // Eğer input tamamen boşsa, otomatik olarak "05" yaz
            let numbers = this.value.replace(/\D/g, '');
            if (numbers.length === 0) {
                this.value = '05';
                this.setSelectionRange(2, 2);
                return;
            }
            
            // Eğer sadece "0" varsa, "05" yap
            if (numbers === '0') {
                this.value = '05';
                this.setSelectionRange(2, 2);
                return;
            }
            
            // Eğer kullanıcı 05'i silmeye çalışıyorsa, tekrar ekle
            if (numbers.length > 0 && !numbers.startsWith('0')) {
                // Kullanıcı 0'ı silmiş, tekrar ekle
                numbers = '05' + numbers;
            } else if (numbers.startsWith('0') && numbers.length === 1) {
                // Sadece "0" varsa, "05" yap
                numbers = '05';
            }
            
            // Formatlanmış değeri al
            const formatted = formatPhoneNumber(numbers);
            this.value = formatted;
            
            // Cursor pozisyonunu ayarla
            const oldNumbers = oldValue.replace(/\D/g, '').length;
            const newNumbers = formatted.replace(/\D/g, '').length;
            
            // Rakam sayısı değişmediyse, cursor pozisyonunu koru (boşluklar hariç)
            if (oldNumbers === newNumbers) {
                // Cursor'ın hangi rakamda olduğunu bul
                let digitCount = 0;
                let newCursorPos = 0;
                for (let i = 0; i < formatted.length && digitCount < cursorPosition; i++) {
                    if (/\d/.test(formatted[i])) {
                        digitCount++;
                    }
                    newCursorPos = i + 1;
                }
                // Eğer boşluk karakterine geldiyse, bir sonraki karaktere geç
                if (formatted[newCursorPos] === ' ') {
                    newCursorPos++;
                }
                this.setSelectionRange(newCursorPos, newCursorPos);
            } else {
                // Rakam eklendi/çıkarıldı, cursor'ı sona al
                this.setSelectionRange(formatted.length, formatted.length);
            }
        });
        
        // Form submit edilmeden önce temizle (sadece rakamlar)
        const form = input.closest('form');
        if (form) {
            form.addEventListener('submit', function(e) {
                input.value = getCleanPhoneNumber(input.value);
            });
        }
        
        // Paste olayında da kontrol et
        input.addEventListener('paste', function(e) {
            e.preventDefault();
            const paste = (e.clipboardData || window.clipboardData).getData('text');
            const formatted = formatPhoneNumber(paste);
            this.value = formatted;
            // Cursor'ı sona al
            this.setSelectionRange(formatted.length, formatted.length);
        });
    }

    // Tüm GSM (telefon) input'larını bul ve ayarla
    // Sadece gerçek GSM telefon numarası alanlarını hedefle, doğrulama kodu alanlarını hariç tut
    document.querySelectorAll('input[name*="gsm"], input[id*="gsm"]').forEach(function(input) {
        // Doğrulama kodu alanlarını hariç tut
        const name = input.name || '';
        const id = input.id || '';
        if (name.includes('validation') || name.includes('verification') || 
            id.includes('validation') || id.includes('verification')) {
            return; // Bu input'u atla
        }
        
        // Pattern attribute'unu kaldır (tarayıcı validasyon mesajını engellemek için)
        if (input.hasAttribute('pattern')) {
            input.removeAttribute('pattern');
        }
        if (!input.hasAttribute('inputmode')) {
            input.setAttribute('inputmode', 'numeric');
        }
        setupGsmInput(input);
    });

    function enforceNumberInputMin(input) {
        if (!input || input.disabled || input.type !== 'number') return;
        var minAttr = input.getAttribute('min');
        if (minAttr === null || minAttr === '') return;
        var min = parseInt(minAttr, 10);
        if (isNaN(min)) return;
        if (input.value === '') return;
        var val = parseInt(input.value, 10);
        if (isNaN(val)) {
            input.value = '';
            return;
        }
        if (val < min) {
            input.value = String(min);
        }
    }

    document.body.addEventListener('input', function(e) {
        if (e.target.matches('input[type=number]')) {
            enforceNumberInputMin(e.target);
        }
    });

    document.body.addEventListener('change', function(e) {
        if (e.target.matches('input[type=number]')) {
            enforceNumberInputMin(e.target);
        }
    });
});

window.jQuery = $;
window.$ = $;
window.moment = moment;

window.timeSelected = function(hour) {
    console.log(hour);
    $('#hour').val(hour);
}
